/* eslint-disable */
const hash = {
  "en-US": "08dbf18b",
  "de-DE": "493f5daf",
  "es-ES": "7ce95070",
  "fr-FR": "38a1e105",
  "id-ID": "e44bce80",
  "it-IT": "5eeea304",
  "jp-JP": "ef5da83e",
  "ko-KO": "ebfe90a2",
  "nl-NL": "d7cad763",
  "pl-PL": "b99425a4",
  "pt-PT": "d0f38bca",
  "ru-RU": "edbce612",
  "sv-SE": "70e7b678",
  "tr-TR": "cec11303",
  "vi-VN": "67b04796",
  "zh-CN": "3b4e5656",
  "zh-TW": "d840ae86",
  "avatars": "cfa0a7dc",
  "control": "f8f554ba",
  "plan-details": "ed4f352f",
  "gov-EN": "270b399e",
  "en-GB": "64044ee2"
}
export default hash
